class ApiError extends Error {
  constructor({ statusCode, message, detail, payload }) {
    super(message || detail || 'Request failed');

    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.detail = detail;
    this.payload = payload;
  }
}

export default ApiError;
